import { storageLanguage } from "helpers";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";

export const languages = ["kk", "ru", "en"];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: storageLanguage(),
    debug: false,
    whitelist: languages,
    detection: {
      order: ["queryString", "cookie"],
      cache: ["cookie"],
    },
    interpolation: {
      escapeValue: false,
    },
    returnedObjectHandler: (key, value) => {
      return typeof value === "object" && value !== null ? JSON.stringify(value) : value;
    },
  });

export default i18n;
